import { Content } from './types'

const figure: Content = {
    type: 'figure',
    name: 'Figuur',
}

export default figure
